export const COOKIE_PREFERENCES_FRAGMENT = 'cookie-preferences';
